import { createStore } from 'satcheljs';
import { IChannelViewState } from './schema/IChannelViewState';

export const getStore = createStore<IChannelViewState>('ChannelState', {
  active: {},
  errors: {}
});
